import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { environmentState } from '~/state/atoms/engineAtoms';
import {
    domainEventBus,
    WindowLevelDeltaEvent,
    WindowLevelSetEvent,
} from '~/domain/events';

/**
 * Handler for windowing domain events.
 * Subscribes to WindowLevelDeltaEvent and WindowLevelSetEvent
 * and updates the environment's window level accordingly.
 *
 * Images are identified by their DICOM Series Instance UID (seriesUid),
 * which allows supporting N images with independent windowing.
 */
export function useWindowingHandlers() {
    const environment = useRecoilValue(environmentState);

    useEffect(() => {
        if (!environment) {
            return;
        }

        const handleDelta = (event: WindowLevelDeltaEvent) => {
            environment.adjustImageWindowLevel(event.delta, event.seriesUid);
        };

        const handleSet = (event: WindowLevelSetEvent) => {
            environment.setImageWindowLevel(event.windowLevel, event.seriesUid);
        };

        const subscriptions = [
            domainEventBus.subscribe(
                WindowLevelDeltaEvent.EVENT_TYPE,
                handleDelta
            ),
            domainEventBus.subscribe(WindowLevelSetEvent.EVENT_TYPE, handleSet),
        ];

        return () => {
            subscriptions.forEach((sub) => sub.unsubscribe());
        };
    }, [environment]);
}
